import { useCallback } from "react";
import { Grid, Divider, Typography } from "@material-ui/core";
import { Box, Button, List, ListItem } from "~/components/UI";
import Highlighter from "react-highlight-words";
import history from "~/packages/history";
import ROUTES from "~/constants/routes";
import { useTranslation } from "react-i18next";

interface ServiceCategoryResultProps {
  data?: Api.SearchResult<ServicesCategoriesApi.ServicesCategoryDto>;
  searchQuery: string;
}

const ServiceCategory = ({
  servicesCategory,
  searchQuery,
}: {
  searchQuery: string;
  servicesCategory: ServicesCategoriesApi.ServicesCategoryDto;
}) => {
  const openGroup = useCallback(() => {
    history.push(
      `${ROUTES.SERVICES_CATEGORIES}?categoryId=${servicesCategory.id}`
    );
  }, [servicesCategory]);

  return (
    <ListItem button onClick={openGroup}>
      <Typography variant="body2" color="textSecondary">
        <Highlighter
          searchWords={[searchQuery]}
          textToHighlight={servicesCategory.name}
        />{" "}
        [
        <Typography variant="body2" component="span" color="primary">
          ID
        </Typography>
        :{" "}
        <Highlighter
          searchWords={[searchQuery]}
          textToHighlight={servicesCategory.id}
        />
        ]
      </Typography>
      <Divider />
    </ListItem>
  );
};

/**
 * @memberof GlobalSearch
 * @component
 * @desc Render of search results for the Groups catalog.
 * @property {string} searchQuery - the text we are looking for
 * @property {Api.SearchResult<ServicesCategoriesApi.ServicesCategoryDto>} data - api response
 */

const Groups = ({ data, searchQuery }: ServiceCategoryResultProps) => {
  const { t } = useTranslation();

  const onShowAll = useCallback(() => {
    setTimeout(() => {
      history.push(`${ROUTES.SERVICES_CATEGORIES}?search=${searchQuery}`);
    }, 0);
  }, [searchQuery]);

  if (data && data.count) {
    return (
      <Box mb={4}>
        <Box py={4}>
          <Grid container alignItems="center">
            <Grid item sm>
              <Typography variant="subtitle1">
                {t("title.servicesCategories")} ({data.count})
              </Typography>
            </Grid>
            <Grid item>
              <Button variant="outlined" onClick={onShowAll}>
                {t("button.showAll")}
              </Button>
            </Grid>
          </Grid>
        </Box>
        <List>
          {data.data.map((s, index) => (
            <ServiceCategory
              key={index}
              searchQuery={searchQuery}
              servicesCategory={s}
            />
          ))}
        </List>
      </Box>
    );
  } else {
    return null;
  }
};

export default Groups;
